<small class="debug">{{me}}</small>
<div style="width: 100%;height: 100%;">
  @if (_ready) {
    <div class="chartContainer" style="width: 100%; height: 100%" >
      <highcharts-chart  style="display: flex;"  [callbackFunction]="chartCallback" [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="logChartInstance($event)"></highcharts-chart>
      <!-- <ngx-charts-bar-vertical-2d
      [scheme]="colorScheme"
      [results]="multi"
      [gradient]="gradient"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [legend]="showLegend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      (select)="onSelect($event)">
    </ngx-charts-bar-vertical-2d> -->
  </div>
}
@if (!_ready) {
  <div>
    <app-loading [@fadeInOutAnimation] [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
  </div>
}
</div>
